/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import { useToast } from '../../../../components/Toats';
import { StepperComponent } from '../../../../../../_metronic/assets/ts/components';
import { KTSVG } from '../../../../../../_metronic/helpers';
import { LoadingSpan } from '../../../../components/Loadings/loadingSpan';
import { putPlantOne } from '../../../../../services/plantsService';

type Props = {
    id: string | null | undefined;
    data: any;
    show: boolean;
    handleClose: () => void
}


const modalsRoot = document.getElementById('root-modals') || document.body

const ModalArquivePlant = ({show, handleClose, id, data}: Props) => {

  const { toggleToast } = useToast();
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [loading, setLoading] = useState(false)
  
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const closed = () => {
    handleClose()
  }

  const arquivePlantSubmit = async () => {
    try {
      setLoading(true)
      const body = {
        arquive : data && data.arquive === "ARQUIVADA" ? "DESARQUIVADA" : "ARQUIVADA"
      }
      await putPlantOne(id ? id : "", body);
      toggleToast("Sucesso ao editar a usina. ", "success")

    } catch (error) {
      console.log('erro',error)
      toggleToast("Erro ao editar a usina. ", "error")
    }finally{
      setLoading(false)
      closed()
      // handleClose()
    //   setTimeout(()=>{
    //     window.location.reload()
    //   }, 2000);
    }
  }

  const submit = () => {
    arquivePlantSubmit()
  }


  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={show}
      onHide={closed}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{data && data.arquive === "ARQUIVADA" ? "Desarquivar" : "Arquivar"} Usina {" - "}{data && data.name ? data.name : "Não identificado"}</span>
          {/* <span className='text-muted mt-1 fw-semibold fs-5'>( {unitBranch.name} )</span> */}
        </h3>

        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
        {/* end::Close */}
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        {/*begin::Stepper */}
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
         

          {/*begin::Content */}
          <div className='flex-row-fluid py-lg-0'>
            <div style={{marginBottom: '3rem'}}>
                <h3 className='card-title align-items-start flex-column'>
                    {
                      data && data.arquive === "ARQUIVADA" ?
                      <span className='text-muted mt-1 fw-semibold fs-5'>Deseja desarquivar a usina e coloca-la no monitoramento?</span>
                      :
                      <span className='text-muted mt-1 fw-semibold fs-5'>Deseja arquivar a usina e remove-la do monitoramento?</span>
                    }
                </h3>
            </div>
            {/*begin::Form */}
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <button
                    type='button'
                    className='btn btn-lg btn-light'
                    disabled={loading}
                    onClick={() => {
                        closed()
                    }}
                    //data-kt-stepper-action='submit'
                >
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr063.svg'
                        className='svg-icon-3 ms-2 me-0'
                    />
                    <span style={{marginLeft: '0.5rem'}}>Cancelar</span>
                    
                </button>

                <button
                    type='button'
                    className={`btn btn-lg btn-${data && data.arquive === "ARQUIVADA" ? "success" : "danger"}`}
                    disabled={loading}
                    //data-kt-stepper-action='submit'
                    onClick={submit}
                >
                    {data && data.arquive === "ARQUIVADA" ? "Desarquivar" : "Arquivar"}
                    {
                        loading ? 
                        <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                        :
                        <KTSVG
                            path='/media/icons/duotune/arrows/arr064.svg'
                            className='svg-icon-3 ms-2 me-0'
                        />
                    }
                </button>
            </div>
            {/*end::Form */}
          </div>
          {/*end::Content */}
        </div>
        {/* end::Stepper */}
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalArquivePlant}
